/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Content\Header\HeaderCart\HeaderCart.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Wednesday July 10th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday July 10th 2024 9:23:38 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Styles from 'Content/Header/HeaderIcons/HeaderIcons.module.css';
import { Tooltip } from "@mui/material";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import translator from "MultiLanguage/TranslationWrapper";
import { useInteractiveHeader } from "Router/HeaderInteractionProvider";
import { Link } from "react-router-dom";
import { AiOutlineShoppingCart } from 'react-icons/ai';

export default function HeaderCart() {
    const InterractiveHeader = useInteractiveHeader();

    return (
        <Tooltip className={`${Styles.options}`} title={translator.decode("cart.title")}>
            <Link className={`${Styles.iconLike}`} to={RouterPathResolver.routeCart.path}>
                <span className={`${Styles.infoBulle}`}>{InterractiveHeader.OfferCount}</span>
                <AiOutlineShoppingCart/>
            </Link>
        </Tooltip>
    );
};
